import * as React from 'react';

import { IDocument, IPosterImage } from '../../infrastructure/interfaces';
import Radio from '../Radio';

export interface IPosterImageBackgroundEditorFormProps {
  document: IDocument;
  posterImagesList: IPosterImage[];
  onPosterImageChangeBackground(image: any): void;
  className: string;
}

export default class PosterImageBackgroundEditorForm extends React.Component<IPosterImageBackgroundEditorFormProps> {

  render() {
    return (
      <div className={this.props.className}>
        {this.props.posterImagesList.map((image, key) => (
          <div key={image.id} className="rowStepTwo">
            <Radio
              checked={(this.props.document.posterImageBackground && this.props.document.posterImageBackground.id === image.id)!}
              onChange={() => this.props.onPosterImageChangeBackground(image)}
            >
              <div className="image-box">
                <img alt={image.name} src={image.web_image_path} />
                <span>{image.name}</span>
              </div>
            </Radio>
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentEditor/PosterImageBackgroundEditorForm.tsx